<template>
  <div class="w-full 2xl:max-w-lg">
    <div class="relative">
      <div class="relative">
        <i
          v-if="searchDefault"
          class="absolute top-0 right-0 mt-3 text-xl text-gray-400 transition duration-200 cursor-pointer fal fa-times-circle hover:text-black"
          @click="clearSearch"
        />
        <i
          v-else
          class="absolute top-0 right-0 mt-4 text-gray-400 fal fa-search"
        />
        <input
          v-model="searchDefault"
          type="text"
          :placeholder="store.locales[lang].search"
          class="pr-6"
          @input="openSuggest"
          @change="searchBlur"
        >
      </div>

      <GeoSuggest
        country="be"
        :types="['(regions)']"
        :search="searchDefault"
        :suggestion="geosuggest.selectedSuggestion"
        @geocoded="geocode($event)"
      >
        <template #default="{ suggestions }">
          <div
            v-if="suggestions.length && geosuggest.open"
            class="absolute left-0 z-50 w-full top-full"
          >
            <ul class="py-1 bg-white shadow-sm">
              <li
                v-for="(suggestion, index) in suggestions"
                :key="index"
                class="px-3 py-2 text-lg transition duration-200 cursor-pointer hover:bg-gray-100"
                @click="setSuggestion(suggestion)"
              >
                <span class="font-bold">{{ formatDescription(suggestion.description, suggestion.matchedSubstrings)[0] }}</span><span class="opacity-70">{{ formatDescription(suggestion.description, suggestion.matchedSubstrings)[1] }}</span>
              </li>
            </ul>
          </div>
        </template>
      </GeoSuggest>
    </div>
  </div>
</template>

<script>
import { GeoSuggest, loadGmaps } from "vue-geo-suggest";

import bus from "../js/bus.js";

const state = require("querystate")();

export default {
  components: {
    GeoSuggest,
  },
  props: ["store", "lang"],
  data() {
    return {
      search: "",
      searchDefault: "",
      searchEdited: false,
      geosuggest: {
        open: false,
        selectedSuggestion: null,
        address: null,
      },
    };
  },
  mounted() {
    loadGmaps("AIzaSyD5l9tULwAjtCepaEn8IcMpVrYGO8LeHL4");

    bus.$on("updateData", (item) => {
      if (item.id === "location") {
        this.searchDefault = item.data.region;
      }
    });

    this.$nextTick(() => {
      if (state.get("region")) {
        this.searchDefault = decodeURI(state.get("region"));
      }
    });
  },
  methods: {
    formatDescription(description, matchedSubstrings) {
      const search = description.replace(/,[^,]+$/, "");
      const matches = description.substr(
        matchedSubstrings.offset,
        matchedSubstrings.length
      );
      const unmatched = search.substr(matchedSubstrings.length, search.length);
      return [matches, unmatched];
    },
    clearSearch() {
      this.searchDefault = "";
      bus.$emit("setData", {
        id: "location",
        data: {
          location: false,
          region: "",
        },
      });
    },
    searchBlur() {
      if (!this.searchDefault) {
        bus.$emit("setData", {
          id: "location",
          data: {
            location: false,
            region: "",
          },
        });
      }
    },
    openSuggest() {
      this.searchEdited = true;
      this.geosuggest.open = true;
    },
    closeSuggest() {
      this.geosuggest.open = false;
    },
    setSuggestion(suggestion) {
      this.geosuggest.selectedSuggestion = suggestion;
      this.closeSuggest();
    },
    geocode($event) {
      this.searchDefault = $event.name;

      if ($event.normalizedAddress.postalCode) {
        if (isNaN(this.searchDefault)) {
          this.searchDefault += ` (${$event.normalizedAddress.postalCode})`;
        } else {
          this.searchDefault += ` (${$event.normalizedAddress.city})`;
        }
      }

      bus.$emit("setData", {
        id: "location",
        data: {
          location: $event.location,
          region: this.searchDefault,
        },
      });
    },
  },
};
</script>
